<template>
    <div class="page account-area">
        <div class="page-content">
            <div class="dz-height">

            </div>
            <div class="fixed-content container">
                <div class="tabs">
                    <div class="tab tab-active form-elements tabs">
                        <form class="tab tab-active" id="tabA1" novalidate="" v-on:submit.prevent="submit">
                            <div class="title-head" style="margin-bottom: 20px">
                                <h2 class="title" style="text-align: center;">
                                    <i class="las la-user-plus"></i>    
                                    Crie sua conta
                                </h2>
                                <p style="text-align: center; color: #666">Preencha suas informações abaixo para realizar o cadastro e trabalhar como <b>profissional</b> ou <b>empresa</b> no aplicativo.</p>
                            </div>
                            <div class="list" style="margin-top: 0px !important">
                                <ul class="row">
                                    <li class="tipo-usuario item-content col-100 mb-5">
                                        <div class="item-inner">
                                            <button type="button" v-on:click="form.tipo = 'prestador';" v-bind:class="{'color-primary': form.tipo == 'prestador', 'button-fill': form.tipo == 'prestador', 'color-gray': form.tipo != 'prestador'}" class="button button-small button-round">
                                                <i class="las la-first-aid"></i> Cadastro para profissionais
                                            </button>

                                        </div>
                                    </li>
                                    <li class="tipo-usuario item-content col-100" style="margin-bottom: 35px">
                                        <div class="item-inner">
                                            <button type="button" v-on:click="form.tipo = 'empresa';" v-bind:class="{'color-primary': form.tipo == 'empresa', 'button-fill': form.tipo == 'empresa', 'color-gray': form.tipo != 'empresa'}" class="button button-small button-round">
                                                <i class="las la-store"></i> Cadastro para empresas
                                            </button>

                                        </div>
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Qual a sua profissão? <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <select id="categoriaCod" class="form-control" name="categoriaCod" required="" v-model="form.categoriaCod">
                                                    <option value="" disabled selected hidden>Toque para selecionar..</option>
                                                    <option v-for="(item, index) in profissoes.itens" :value="item.cod" :key="item.cod">{{item.nome}}</option>
                                                   
                                                </select>                                                  
                                            </div>
                                        </div>
                                    </li>        
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Tipo da empresa <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <select id="categoriaCod" class="form-control" name="categoriaCod" required="" v-model="form.categoriaCod">
                                                    <option value="" disabled selected hidden>Toque para selecionar..</option>
                                                    <option v-for="(item, index) in profissoes.itens" v-if="item.empresa == 1" :value="item.cod" :key="item.cod">{{item.nome}}</option>
                                                   
                                                </select>                                                  
                                            </div>
                                        </div>
                                    </li>                                       
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Especialidade(s) <small>(opcional)</small></div>
                                            <div class="item-input-wrap" v-on:click="autocompleteEspecialidades()">
                                                <input type="text" placeholder="Toque para selecionar.." value="" class="form-control" v-model="especialidades.nomes" />
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label" v-if="profissoes.ativa.empresa == 0 && form.tipo != 'empresa'">Nome <small>(obrigatório)</small></div>
                                            <div class="item-title item-label" v-if="profissoes.ativa.empresa == 1 || form.tipo == 'empresa'">Nome do responsável pela empresa <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.nome" placeholder="Escreva o nome aqui" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="profissoes.ativa.empresa == 1">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Nome fantasia <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.empresa" placeholder="Nome da empresa" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="profissoes.ativa.empresa == 1">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Razão social da empresa <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.razaoSocial" placeholder="Escreva a razão social" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' && profissoes.ativa.empresa == 0">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Registro de classe <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.registroClasse" placeholder="Escreva aqui.." value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>                                        
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' && profissoes.ativa.empresa == 0">
                                        <div class="item-inner">
                                            <div class="item-title item-label">RQE <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="number" v-model="form.rqe" placeholder="Escreva seu RQE se possuir.." value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>  
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label" v-if="form.tipo == 'contratante'">CPF <small>(obrigatório)</small></div>
                                            <div class="item-title item-label" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">CPF do responsável <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['###.###.###-##']" type="tel" class="form-control" autocomplete="new-password" v-model="form.doc" placeholder="Informe seu CPF" required />
                                            </div>
                                        </div>
                                    </li>            
                                    <li class="item-content item-input col-100" v-if="(form.tipo == 'prestador' || form.tipo == 'empresa') && profissoes.ativa.empresa == 1">
                                        <div class="item-inner">
                                            <div class="item-title item-label">CNPJ <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask type="tel" :mask="['##.###.###/####-##']" class="form-control" v-model="form.cnpj" :placeholder="'Informe o CNPJ da empresa'"/>
                                            </div>
                                        </div>
                                    </li>                                                                   
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">E-mail <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="email" v-model="form.email" placeholder="Escreva seu melhor e-mail" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Celular <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="form-control" placeholder="Escreva seu celular" autocomplete="new-password" v-model="form.telefone" />
                                            </div>
                                        </div>
                                    </li>                                                                            
                                    <li class="item-content item-input col-100" v-if="profissoes.ativa.empresa == 0 && form.tipo != 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label" v-if="form.tipo == 'contratante'">Data de nascimento <small>(obrigatório)</small></div>
                                            <div class="item-title item-label" v-if="form.tipo == 'prestador'">Data de nascimento do responsável <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['##/##/####']" :masked="true" type="tel" placeholder="Sua data de nascimento" value="" class="form-control" autocomplete="new-password" v-model="form.dataNascimento"  required />
                                            </div>
                                        </div>
                                    </li>                                                                        
                                    <li class="item-content col-100 item-input">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Senha <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="password" v-model="form.senha" placeholder="Sua melhor senha" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content col-100 item-input">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Confirmação da senha</div>
                                            <div class="item-input-wrap">
                                                <input type="password" v-model="form.senhaConfirmacao" placeholder="Confirme a senha" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>   
                                </ul>

                                <p v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                    <i class="las la-map-marker"></i> 
                                    Endereço
                                </p>

                                <ul class="row">
                                    <li class="item-content item-input col-60" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">CEP <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <the-mask :mask="['#####-###']" :masked="true" type="tel" class="form-control" v-model="form.cep" placeholder="_____-___" />
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Rua <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.endereco" placeholder="Escreva o seu endereço.." value="" class="form-control" @change="checkEndereco"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Número (obrigatório)</div>
                                            <div class="item-input-wrap">
                                                <input type="tel" v-model="form.numero" placeholder="__" value="" class="form-control" @change="checkEndereco"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Complemento <small>(opcional)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.complemento" placeholder="" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Bairro <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.bairro" placeholder="Escreva o seu bairro.." value="" class="form-control" @change="checkEndereco"/>
                                            </div>
                                        </div>
                                    </li>            
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Cidade <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <input type="text" v-model="form.cidade" placeholder="Escreva a sua cidade.." value="" class="form-control" @change="checkEndereco"/>
                                            </div>
                                        </div>
                                    </li>     
                                    <li class="item-content item-input col-100" v-if="form.tipo == 'prestador' || form.tipo == 'empresa'">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Estado <small>(obrigatório)</small></div>
                                            <div class="item-input-wrap">
                                                <select id="estado" class="form-control" readonly="" name="estado" required="" v-model="form.estado" @change="checkEndereco">
                                                    <option value="" disabled selected hidden>Estado</option>
                                                    <option value="AC">Acre</option>
                                                    <option value="AL">Alagoas</option>
                                                    <option value="AP">Amapá</option>
                                                    <option value="AM">Amazonas</option>
                                                    <option value="BA">Bahia</option>
                                                    <option value="CE">Ceará</option>
                                                    <option value="DF">Distrito Federal</option>
                                                    <option value="ES">Espírito Santo</option>
                                                    <option value="GO">Goiás</option>
                                                    <option value="MA">Maranhão</option>
                                                    <option value="MT">Mato Grosso</option>
                                                    <option value="MS">Mato Grosso do Sul</option>
                                                    <option value="MG">Minas Gerais</option>
                                                    <option value="PA">Pará</option>
                                                    <option value="PB">Paraíba</option>
                                                    <option value="PR">Paraná</option>
                                                    <option value="PE">Pernambuco</option>
                                                    <option value="PI">Piauí</option>
                                                    <option value="RJ">Rio de Janeiro</option>
                                                    <option value="RN">Rio Grande do Norte</option>
                                                    <option value="RS">Rio Grande do Sul</option>
                                                    <option value="RO">Rondônia</option>
                                                    <option value="RR">Roraima</option>
                                                    <option value="SC">Santa Catarina</option>
                                                    <option value="SP">São Paulo</option>
                                                    <option value="SE">Sergipe</option>
                                                    <option value="TO">Tocantins</option>
                                                </select>                                                  
                                            </div>
                                        </div>
                                    </li>   
                                </ul>                                  
                            </div>
                            <div class="clearfix">
                                <p class="mb-20" style="text-align: center; line-height: 120%;">
                                    Ao efetuar seu cadastro, você concorda com os nossos <a v-on:click="$root.openModal('modal-termos-de-uso')"><b>Termos de Uso</b></a> e a <a v-on:click="$root.openModal('modal-politicas-de-privacidade')"><b>Política de Privacidade</b></a>.
                                </p>                                     
                                <button type="submit" class="link external button-large button button-fill">
                                    <i class="las la-check-circle"></i>
                                    Efetuar cadastro
                                </button>
                            </div>
                            <div class="text-align-center account-footer">
                                <p class="mt-0">Já tem cadastro?</p>
                                <router-link :to="{'name': 'Login'}" class="link external button-large button button-fill button-gray">FAÇA LOGIN</router-link>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>      
</template>

<script>
export default {
    name:                           'Cadastro',
    data () {
        var self                    = this;
        return {
            "profissoes": {
                "ativa":            {
                    "empresa":      0
                },
                "itens":            []
            },                
            termos:                 true,
            loading: {
                "submit":           false,
            },
            "especialidades": {
                "nomes":            "",
                "valor":            [
                ],
                "itens":            [                  
                ]
            },            
            form: {
                "nome":             null,
                "email":            null,
                "tipo":             "prestador",
                "telefone":         "",
                "doc":              "",
                "estado":           "",
                "cnpj":             "",
                "empresa":          "",
                "razaoSocial":      "",
                "dataNascimento":   null,
                "senha":            null,
                "senhaConfirmacao": null,
                "categoriaCod":     "",
                "dispositivo":      self.$root.mobile.osName
            }
        }
    },
    watch: {
        "form.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },
        "form.categoriaCod": function(val) {
            var self = this;
            console.log("change categoriaCod", val);
            var profissao = self.profissoes.itens.filter(function(item) {
                if (item.cod == val) return item;
            })[0];

            if (!profissao) profissao = {
                "empresa":      0                
            };

            console.log("Profissao:", profissao);
            self.profissoes.ativa = profissao;
            self.$forceUpdate();
        },   
    },    
    methods: {    
        aceitarTermos: function() {
            var self = this;
            console.log("aceitarTermos");
            self.form[window.termos.campo] = true;
            if (window.__app.modal["modal-termos-de-uso"]) window.__app.modal["modal-termos-de-uso"].close();
            if (window.__app.modal["modal-politicas-de-privacidade"]) window.__app.modal["modal-politicas-de-privacidade"].close();

            self.submit();
        },
        negarTermos: function() {
            var self = this;
            console.log("negarTermos");
            self.form[window.termos.campo] = false;
            if (window.__app.modal["modal-termos-de-uso"]) window.__app.modal["modal-termos-de-uso"].close();
            if (window.__app.modal["modal-politicas-de-privacidade"]) window.__app.modal["modal-politicas-de-privacidade"].close();

            alert("Para prosseguir com o seu cadastro é necessário aceitar os termos apresentados.");
        },           
        autocompleteEspecialidades: function() {
            var self = this;
            console.log("autocompleteEspecialidades()");

            self.autocomplete = window.___app.autocomplete.create({
                openIn: 'popup',
                multiple: true,
                requestSourceOnOpen: true,
                closeOnSelect: false,
                valueProperty: 'cod',
                textProperty: 'nome',
                popupCloseLinkText: "Fechar",
                notFoundText: "Nenhum resultado encontrado.",
                searchbarDisableText: "Cancelar",
                searchbarPlaceholder: "Pesquise..",
                value: self.especialidades.valor,
                source: function (query, render) {
                    var autocomplete = this;
                    var results = [];
                    autocomplete.preloaderShow();

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(query);

                    if (!self.form.categoriaCod) {
                        console.log("Erro autocomplete", self.autocomplete);
                        setTimeout(function() {
                            self.autocomplete.close();
                        }, 1000);
                        alert("Selecione a sua profissão.");
                        return false;
                    }

                    self.especialidades.itens.forEach(function(item) {
                        if ((clean(item.nome).indexOf(search) != -1) && item.categoriaCod == self.form.categoriaCod) {
                            itens.push(item);
                        }
                    });
                    autocomplete.preloaderHide();
                    render(itens);

                },
                on: {
                    change: function (value) {
                        console.log("change", value);
                        self.especialidades.valor = value;

                        var nomes   = "";

                        value.forEach(function(item) {
                            nomes += item.nome + ", ";
                        });

                        nomes       = nomes.substr(0, nomes.length - 2);

                        self.especialidades.nomes = nomes;

                        self.$forceUpdate();
                    },
                }                
            });

            console.log("autocomplete:", self.autocomplete)

            self.autocomplete.open();

        },        
        checkEndereco: function() {
            var self                    = this;
            if (self.form.tipo == "prestador") {
                if (self.form.endereco && self.form.bairro && self.form.cidade && self.form.estado && self.form.cep && (!self.form.latitude && !self.form.longitude)) {
                    self.getLocalizacao();
                }
            }
        },
        initMapa: function() {
            var self                    = this;

            var position        = {lat: parseFloat(self.form.latitude), lng: parseFloat(self.form.longitude)};   
            self.mapa           = new google.maps.Map(document.getElementById('map'), {
                center:         position,
                disableDefaultUI: true,
                zoom:           20
            });

        },
        setLocalizacao: function() {
            var self            = this;
            var position        = {lat: parseFloat(self.form.latitude), lng: parseFloat(self.form.longitude)};   
            self.mapa.setCenter(position);
            if (self.marker)    self.marker.setMap(null);
            self.marker         = new google.maps.Marker({
                position:       position,
                map:            self.mapa,
                draggable:      true,
                title:          'Arraste'
            });     
            google.maps.event.addListener(self.marker, 'drag', function() {
                self.form.latitude  = self.marker.getPosition().lat();
                self.form.longitude = self.marker.getPosition().lng();
            });                             
        },
        getLocalizacao: function() {
            var self                    = this;

            var geocoder                = new google.maps.Geocoder();
            var endereco                = self.form.endereco + ", " + self.form.numero + " - " + self.form.bairro + ", " + self.form.cidade + " - " + self.form.estado + ", " + self.form.cep;
            geocoder.geocode({ 'address': endereco}, function (results, status) {

                if (results[0]) {

                    var latitude        = results[0].geometry.location.lat();
                    var longitude       = results[0].geometry.location.lng();
                    self.form.latitude  = latitude; 
                    self.form.longitude = longitude; 

                    self.$forceUpdate();
                    if (!self.mapa) self.initMapa();
                    self.setLocalizacao();
                    
                }

            });                 
        },           
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "all":          true
                    }
                };

                axios.get("api/categorias.php", form)
                .then(response => {
                    
                    console.log("getCategorias() response", response);
                    self.categorias                     = response.data.result;

                    console.log("Buscou categorias", self.categorias);

                    var profissoes      = [];
                    var especialidades  = [];

                    self.categorias.itens.forEach(function(item) {
                        if (item.tipo == "profissao") {
                            profissoes.push(item);
                        }
                        if (item.tipo == "especialidade") {
                            especialidades.push(item);
                        }                        
                    });

                    self.especialidades.itens   = especialidades;
                    self.profissoes.itens       = profissoes;

                    console.log("Setou especialidades e profissoes", self.especialidades, self.profissoes)

                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCategorias() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                           
                });   

            });   
        },            
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.form.endereco  = response.data.logradouro;
                                self.form.bairro    = response.data.bairro;
                                self.form.cidade    = response.data.localidade;
                                self.form.estado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },  
        submit: function(e) {
            var self            = this;

            console.log("submit()");

            if (!self.form.termos) {
                window.termos.campo = "termos";
                self.$root.openModal('modal-termos-de-uso', null, true);
                return false;
            } else if (!self.form.politicas) {
                window.termos.campo = "politicas";
                self.$root.openModal('modal-politicas-de-privacidade', null, true);
                return false;
            } 

            console.log("submit() passou");

            if (self.form.tipo == "prestador" || self.form.tipo == "empresa") {
                self.form.categoriasNomes       = self.especialidades.nomes;
                self.form.categorias            = [];
                self.especialidades.valor.forEach(function(item) {
                    self.form.categorias.push(item.cod);
                });
                self.form.categorias            = self.form.categorias.join(",");
            } 

            var form = JSON.parse(JSON.stringify(self.form));

            if (form.tipo == "empresa") form.tipo = "prestador";

            console.log("FORM", form);
            if (e) e.preventDefault();
            self.loading.submit = true;
            loading.show();
            axios.post("api/cadastro.php", form)
            .then(response => {
                console.log("submit() response", response.data)
                // self.loading.submit = false;
             
                if (response.data.user) {
                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            window.location.reload();
                        }, 200);
                    })
                } else {
                    loading.hide();
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }
    },
    activated: function() {
        var self = this;
        window.termos = {
            aceitar:    self.aceitarTermos,
            negar:      self.negarTermos
        };

        self.getCategorias().finally(function() {
            loading.hide();
        });
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tipo-usuario .button {
        height: 150px;
        text-align: left !important;
        font-size: 16px;
        text-transform: initial;
    }

    .col-100 .button {
        height: auto !important;
        padding: 10px;
        line-height: 130%;
    }
   
    .page-cadastro .form-elements ul .item-content .item-inner .item-input-wrap {
        margin-bottom: 15px !important;
    }

    select {   
        line-height: 50px !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Cadastro.vue